import iconArr from './iconArr'
/**
 * Компонент обертка для массива иконок
 * @param {Integer} iconNum Номер иконки в массиве
 * @param {Any[]} ...rest параметры которые будут переданы этой иконке без изменений
 */
const GeoIconArray = ({iconNum,...rest}) => {
    const RenderedIcon = iconArr?.[iconNum]
    if(!RenderedIcon) return null
    return <RenderedIcon {...rest} />
}

export default GeoIconArray